import React from 'react';
import LibTaskCompletionsModal from '@lib/components/TaskCompletions/TaskCompletionsModal/TaskCompletionsModal';
import { TaskCompletionsModalUrls } from '@lib/components/TaskCompletions/TaskCompletionsModal/types';
import { APP_URLS } from 'constants/urls';

export const taskCompletionsModalUrls: TaskCompletionsModalUrls = {
  getTaskUrl: (id) =>
    APP_URLS.app.tasks.view.getDynamicPath({ pathParts: { id } }),
  getInterventionUrl: (id) =>
    APP_URLS.app.interventions.view.getDynamicPath({ pathParts: { id } }),
  getDocumentationUrl: (id) =>
    APP_URLS.app.documentation.view.getDynamicPath({ pathParts: { id } }),
};

type Props = Omit<
  React.ComponentProps<typeof LibTaskCompletionsModal>,
  'urls' | 'actions' | 'hideCompletionDetails'
>;

// Read-only: no status update or create-intervention — the user app never
// gets `taskCompletionStatusUpdate`, and the create-intervention flow belongs
// to admin's Task Reporting entry points. No completion details (single or
// compare) either.
export default function TaskCompletionsModal(props: Props) {
  return (
    <LibTaskCompletionsModal
      {...props}
      urls={taskCompletionsModalUrls}
      hideCompletionDetails
    />
  );
}
